import {Negotiation} from "@/modules/diplomacy/entity";
import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {Notifier} from "@/modules/notifications/services/Notifier";
import NotificationCreator from "@/modules/youth/notifications/NotificationCreator";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import chance from "@/modules/base/services/chance";
import {BeforeNegotiationEvent} from "@/modules/diplomacy/events/BeforeNegotiationEvent";
import {AfterNegotiationEvent} from "@/modules/diplomacy/events/AfterNegotiationEvent";
import {app} from "@/di";
import {NegotiationCloser} from "@/modules/diplomacy/services/NegotiationCloser";

@injectable()
export class NegotiationEvaluator {
  private readonly progressRangeProgressPerAction: { min: number, max: number, fixed: number };
  private readonly progressRangePatiencePerAction: { min: number, max: number, fixed: number };

  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(Notifier) private notifier: Notifier,
    @inject(NotificationCreator) private notificationCreator: NotificationCreator,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
    // todo
    this.progressRangeProgressPerAction = {min: 5, max: 10, fixed: 2};
    this.progressRangePatiencePerAction = {min: 5, max: 10, fixed: 2};
  }

  public async evaluate(negotiation: Negotiation) {
    const progress = chance.integer(this.progressRangeProgressPerAction);
    const patience = chance.integer(this.progressRangePatiencePerAction);

    await this.em.emitAsync(new BeforeNegotiationEvent(negotiation, progress, patience));

    negotiation.progress = Math.min(100, negotiation.progress + progress);
    negotiation.patience = Math.max(0, negotiation.patience - patience);
    await negotiation.save();

    await this.em.emitAsync(new AfterNegotiationEvent(negotiation, progress, patience));

    if (negotiation.patienceAbortLimit > negotiation.patience) {
      await app.get(NegotiationCloser).abort(negotiation);
    }
  }
}